<template>
	<div class="row">
		<div class="col col-lg-6">
			<alert-success :form="form" :class="'shadow-sm'" message="Your message has been sent and we will respond within 24 hours."></alert-success>
		
			<form @submit.prevent="sendMessage" @keydown="form.onKeydown($event)">
				<div class="form-row">
					<div class="form-group col-12">
						<label>
							What can we help you with?
							<span>*</span>
						</label>
						<select v-model="form.subject" class="form-control custom-select shadow-sm" :class="{ 'is-invalid': form.errors.has('subject') }" required>
							<option selected :value="null" disabled>Select an option</option>
							<option v-for="(subject, index) in subjects" :value="index">{{ subject }}</option>
						</select>
						<has-error :form="form" field="subject"></has-error>
					</div>
					<div class="form-group col-md-12" v-show="form.subject === 5">
						<label>
							If "Other", please specify
							<span>*</span>
						</label>
						<input v-model="form.subject_text" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('subject_text') }" placeholder="Please specify" />
						<has-error :form="form" field="subject_text"></has-error>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label>
							Email
							<span>*</span>
						</label>
						<input v-model="form.email" type="email" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('email') }" placeholder="Enter your email address" required/>
						<has-error :form="form" field="email"></has-error>
					</div>
					<div class="form-group col-md-6">
						<label>Phone Number</label>
						<input v-model="form.phone" type="tel" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('phone') }" placeholder="Enter your phone number" />
						<has-error :form="form" field="phone"></has-error>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label>
							First Name 
							<span>*</span>
						</label>
						<input v-model="form.first_name" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('first_name') }" placeholder="John" required/>
						<has-error :form="form" field="first_name"></has-error>
					</div>
					<div class="form-group col-md-6">
						<label>
							Last Name 
							<span>*</span>
						</label>
						<input v-model="form.last_name" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('last_name') }" placeholder="Doe" required/>
						<has-error :form="form" field="last_name"></has-error>
					</div>
				</div>

				<div class="form-row">
					<div class="form-group col-12">
						<label>
							Message
							<span>*</span>
						</label>
						<textarea v-model="form.message" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('message') }" :rows="(form.subject === 5) ? 8:10" placeholder="Message body" required></textarea>
						<has-error :form="form" field="message"></has-error>
					</div>
				</div>

				<button :disabled="form.busy" type="submit" class="btn btn-default btn-block shadow-sm">Submit Form</button>
			</form>
		</div>
	</div>
</template>

<style scoped>
	span {
		color: red;
	}
</style>

<script>
	export default {
		data() {
			return {
				subjects: this.$store.getters.contact_subjects,
				form: new Form({
					subject: this.$route.query.subject
						? this.$route.query.subject
						: null,
					subject_text: null,
					email: null,
					phone: null,
					first_name: null,
					last_name: null,
					message: null
				})
			};
		},
		watch: {
			"form.subject": function(subject) {
				this.form.subject_text = null;

				if (subject !== 5) {
					this.form.subject_text = this.subjects[subject];
				}
			}
		},
		methods: {
			sendMessage() {
				this.form.post("/contact-us").then(({ data }) => {
					this.form.reset();
				});
			}
		}
	};
</script>
